import React from 'react'
import styles from './ChatAttachments.module.css'
import FileAttachment from './FileAttachment'
import {getFileTypeByContentType} from '../../../../util/functions'
const ChatAttachments = (props) => {
    const { fileToSend = [],onRemoveFileFromAttachmentsClicked } = props

    const fileAttachmentsContainers = fileToSend.map((file) => {
        let fileName
        let fileType
        let id
        if (file._id) { // its attachment from galler
            fileName = file.fileName
            fileType = file.fileType
            id = file._id
        }
        else { // its attachment without gallery
            fileName = file.name
            fileType = getFileTypeByContentType(file.type)
            id = file.lastModified
        }
        return (
            <FileAttachment
                key={id}
                fileName={fileName}
                fileType={fileType}
                id={id}
                onRemoveFileFromAttachmentsClicked={onRemoveFileFromAttachmentsClicked}
            />
        )
    })


    return (
        <section className={styles['attachments-section']}>
            {fileAttachmentsContainers}
        </section>
    )
}

export default ChatAttachments